var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "title"
  }, [_vm._v("你可以这样问我：")]), _c("div", _vm._l(_vm.dataList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "bubbles",
      on: {
        click: function click($event) {
          return _vm.handleClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };